import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrVisitDiagnosisService {
  temrVisitDiagnosis: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_visit_diagnosis/list/?';
  private AddRecord = webapi + 'temr_visit_diagnosis/create';
  private AddRecordNew = webapi + 'temr_visit_diagnosis/createNew';
  private EditRecord = webapi + 'temr_visit_diagnosis/update';
  private EditVdStatusRecord = webapi + 'temr_visit_diagnosis/changestatusbyid/';
  private GetRecord = webapi + 'temr_visit_diagnosis/byid/';
  private DeleteRecord = webapi + 'temr_visit_diagnosis/delete/';
  private ListRecordByVisitId = webapi + 'temr_visit_diagnosis/listbyid?';
  private GetAllRecordServicebyTimelineId = webapi + 'temr_visit_diagnosis/getAllRecordServicebyTimelineId?';
  private GetAllRecordServicebyAdmissionId = webapi + 'temr_visit_diagnosis/getAllRecordServicebyAdmissionId?';
  private GetAllRecordByTimelineList = webapi + 'temr_visit_diagnosis/getAllRecordByTimelineList';
    private GetFinalDiagnosisInBanner = webapi + 'temr_visit_diagnosis/getFinalDiagnosisInBanner?';

  constructor(private http: Http) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getAllRecordServicebyVisitId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecordByVisitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getAllRecordServicebyTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetAllRecordServicebyTimelineId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getAllRecordServicebyAdmissionId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetAllRecordServicebyAdmissionId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordServiceNew(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecordNew, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editVdStatusRecordService(id: any, booleanValue: any) {
    return this.http.put(this.EditVdStatusRecord + id + '/' + booleanValue, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getFinalDiagnosisInBanner(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetFinalDiagnosisInBanner + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-visit-diagnosis/temr-visit-diagnosis.service.ts